import { getEnv } from '@utils/env'
import type { DashboardMetricItemData } from '../types/dashboardMetrics.types'

/** Frontend-only dashboard mocks when the API is unavailable (off by default). */
export function isDashboardDevMocksEnabled(): boolean {
  if (getEnv('REACT_APP_MOCK_DASHBOARD', '') === 'false') {
    return false
  }
  if (getEnv('REACT_APP_MOCK_DASHBOARD', '') === 'true') {
    return true
  }
  if (getEnv('REACT_APP_USE_SETTINGS_MOCKS', '') === 'true') {
    return true
  }
  return false
}

/**
 * Keep metric label/id/goal shells for layout. When mocks are off, blank sample
 * primary values so cards still render without fabricated numbers. Goals
 * (`valueOver`, `rightLabel`) stay — live mappers also read goals from shells.
 */
export function withDashboardMetricShellValues(
  metrics: DashboardMetricItemData[],
  useMockValues: boolean,
): DashboardMetricItemData[] {
  if (useMockValues) {
    return metrics
  }
  return metrics.map((metric) => ({
    ...metric,
    value: '—',
    footer: undefined,
    footerTrend: undefined,
  }))
}
